import { TypeMultiTableHead } from "../../type/componentsType/TkTable";

const mailHeadList: TypeMultiTableHead[] = [
  { headTitle: "テンプレート名" },
  { headTitle: "タイトル" },
  { headTitle: "送信タイミング" },
];

const sendMailList: TypeMultiTableHead[] = [
  { headTitle: "テンプレート名" },
  { headTitle: "タイトル" },
];

export { mailHeadList, sendMailList };
